import { ReactNode } from "react";
import { IconQuestion } from "../../../assets/icons";
import styles from "./description-input-wrapper.module.scss";

interface DescriptionInputWrapperProps {
  children: ReactNode;
  description: string;
}

const DescriptionInputWrapper: React.FC<DescriptionInputWrapperProps> = ({
  children,
  description,
}) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.inputContainer}>{children}</div>
      <IconQuestion className={styles.iconQuestion} title={description} />
    </div>
  );
};

export default DescriptionInputWrapper;
